<template>
  <v-container fluid>
    <register-member/>
  </v-container>
</template>

<script>
  export default {
    name: 'NewMember',
    components: {
      RegisterMember: () => import ('@/components/member/RegisterMember.vue')
    },
  }
</script>

<style lang="scss" scoped>

</style>